import { render, staticRenderFns } from "./EventManagementPage.vue?vue&type=template&id=5421f441"
import script from "./EventManagementPage.vue?vue&type=script&lang=js"
export * from "./EventManagementPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports